import React from 'react';

const PageWrapper: React.StatelessComponent = ({ children }) => (
  <div className="container jg-space-phn">{children}</div>
);

export default PageWrapper;
